<template>
  <div class="all-years-empty-container">
    <!-- 背景パターン -->
    <div class="background-pattern">
      <div v-for="n in 5" :key="n" class="bg-pattern"></div>
    </div>
    
    <!-- メインコンテンツ -->
    <div class="main-content">
      <!-- メッセージカード -->
      <div class="message-card-section">
        <div class="message-card">
          <div class="card-content">
            <!-- クマの画像 -->
            <div class="bear-image">
              <img 
                src="/img/campaign/reality_histories_20m/img_empty_bear.png"
                alt="空の状態のクマ" 
                class="bear-img"
              />
            </div>
            
            <!-- メッセージテキスト -->
            <div class="message-text">
              <p class="message-line">{{ $t('memoriesNoteText2') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

@Component({})
export default class AllYearsEmptyState extends Vue {}
</script>

<style scoped>
.all-years-empty-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  overflow: hidden;
  padding: 0 16px;
}

/* 背景パターン */
.background-pattern {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.bg-pattern {
  width: 100%;
  height: 800px;
  background-image: url('/img/campaign/reality_histories_20m/bg_pattern.png');
  background-size: 100% auto;
  background-repeat: repeat-y;
  background-position: center top;
}

/* メインコンテンツ */
.main-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 28px;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0;
  width: 100%;
  min-height: 100vh;
}


/* メッセージカードセクション */
.message-card-section {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.message-card {
  position: relative;
  width: 100%;
  border-radius: 8px;
  background: linear-gradient(117.818deg, #DC7EFF 0%, #8CAAFD 100%);
  overflow: hidden;
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 60px 16px;
  gap: 16px;
  position: relative;
  width: 100%;
}

/* クマの画像 */
.bear-image {
  position: relative;
  width: 210px;
  height: 100px;
  flex-shrink: 0;
}

.bear-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* メッセージテキスト */
.message-text {
  position: relative;
  width: 311px;
  max-width: 100%;
  flex-shrink: 0;
}

.message-line {
  font-weight: 300;
  font-style: normal;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: normal;
  margin: 0;
  display: block;
}
</style>
